<patron-toolbar>
  <div class="container">
    <div class="flex justify-content-between flex-wrap">
      <div class="my-2 flex align-items-center">
        <div>
          <patron-filter-widget
            [findOptions]="findOptions"
            (onSubmit)="goToFirstPage()"></patron-filter-widget>
        </div>
      </div>
      <div class="my-2">
        <patron-search-widget (onSearch)="onSearch($event)" #searchWidget></patron-search-widget>
      </div>
    </div>
  </div>
</patron-toolbar>

<div class="container">
  <patron-notification-list
    [isFromHeader]="false"
    [findOptions]="findOptions"
    [sent]="sent"></patron-notification-list>
</div>

@if (notificationList) {
  <div>
    <patron-toolbar position="bottom" [class.hidden]="!notificationList.notifications.length">
      <patron-paginator
        [totalRecords]="notificationList.totalItems"
        [findOptions]="findOptions"
        (onPageChange)="paginate($event)"
        #paginator>
      </patron-paginator>
    </patron-toolbar>
  </div>
}
